var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaxGroupsNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-FAX_Groups_Normal"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FAX_Groups_Normal",
    "data-name": "FAX Groups_Normal",
    clipPath: "url(#clip-FAX_Groups_Normal)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fax_Groups",
    "data-name": "Fax Groups",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2109",
    "data-name": "Group 2109",
    transform: "translate(4.495 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4647",
    "data-name": "Path 4647",
    d: "M29.527,15.322H9.79v-7.3A1.516,1.516,0,0,1,11.06,6.7H28.13a1.448,1.448,0,0,1,1.4,1.366v7.272Z",
    transform: "translate(-9.155 -6.065)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4648",
    "data-name": "Path 4648",
    d: "M29.762,16.192H10.025a.637.637,0,0,1-.635-.635v-7.3A2.116,2.116,0,0,1,11.248,6.3H28.365a2.037,2.037,0,0,1,1.429.6,1.984,1.984,0,0,1,.619,1.4v7.272a.637.637,0,0,1-.635.635Zm-19.1-1.27H29.127V8.3a.794.794,0,0,0-.238-.492.83.83,0,0,0-.508-.238H11.343a.916.916,0,0,0-.651.683v6.669Z",
    transform: "translate(-9.39 -6.3)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_56",
    "data-name": "Subtraction 56",
    d: "M-504.129-786.169h-25.758A2.519,2.519,0,0,1-532-788.392v-11.337A2.459,2.459,0,0,1-529.794-802h25.649A2.5,2.5,0,0,1-502-799.808v11.226a2.443,2.443,0,0,1-.725,1.651,2.078,2.078,0,0,1-1.4.731v.031Zm-19.2-1.411a.636.636,0,0,0-.635.635.636.636,0,0,0,.635.635h12.639a.636.636,0,0,0,.635-.635.636.636,0,0,0-.635-.635Zm0-3.191a.636.636,0,0,0-.635.635.636.636,0,0,0,.635.634h12.639a.636.636,0,0,0,.635-.634.636.636,0,0,0-.635-.635Zm15.69-8.709a2.035,2.035,0,0,0-2.032,2.032,2.035,2.035,0,0,0,2.032,2.033,2.035,2.035,0,0,0,2.033-2.033A2.035,2.035,0,0,0-507.638-799.481Z",
    transform: "translate(532 809.308)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_53",
    "data-name": "Subtraction 53",
    d: "M-513.388-787.074h0l0,0,.014-.014h-16.212A2.609,2.609,0,0,1-532-789.853v-11.512a.636.636,0,0,1,.635-.635h19.737a.638.638,0,0,1,.46.191.638.638,0,0,1,.191.46v11.512a2.947,2.947,0,0,1-.667,1.905A2.253,2.253,0,0,1-513.388-787.074Zm-7.53-5.034a.636.636,0,0,0-.635.635.636.636,0,0,0,.635.634h.365a.635.635,0,0,0,.634-.634.636.636,0,0,0-.634-.635Zm-6.875,0a.636.636,0,0,0-.635.635.636.636,0,0,0,.635.634h4.779a.636.636,0,0,0,.635-.634.636.636,0,0,0-.635-.635Zm0-3.191a.636.636,0,0,0-.635.635.636.636,0,0,0,.635.635h12.639a.636.636,0,0,0,.635-.635.636.636,0,0,0-.635-.635Zm0-3.191a.636.636,0,0,0-.635.635.636.636,0,0,0,.635.634h12.639a.636.636,0,0,0,.635-.634.636.636,0,0,0-.635-.635Z",
    transform: "translate(536.466 817.027)",
    fill: "#6f8b8f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaxGroupsNormal);
export default __webpack_public_path__ + "static/media/FAX_Groups_Normal.3429d097e3c4489f7addbe8fdaaafae1.svg";
export { ForwardRef as ReactComponent };